<template lang="pug">
.warning
  template(v-if="noKidsAdded")
    h3.warning__header Добавить обучающегося
    p.warning__text Вы можете добавить не более 7 человек.
  template(v-else)
    h3.warning__header В целях безопасности изменение данных ограничено.
    p.warning__text Для внесения изменений информации о детях, просьба обратиться в техническую поддержку ЦОПП.
  .warning__sevice(v-if="dataSupport")
    .warning__data(v-if="!!dataSupport.email") Электронная почта:&nbsp;
      TextEmail(
        :value="dataSupport.email"
        :inline="true"
      )
    .warning__data(v-if="dataSupport.phone") Телефон технической поддержки:&nbsp;
        ExtPhone(:phone="dataSupport.phone")
</template>

<script>
import ExtPhone from '@/components/ext/Phone.vue';
import TextEmail from '@/components/parts/footer/Email.vue';

export default {
  name: 'CompWarning',

  components: {
    ExtPhone,
    TextEmail,
  },

  props: {
    dataSupport: {
      type: Object,
      default: null,
    },

    noKidsAdded: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="stylus" scoped>
.warning
  margin 36px 0 54px
  padding 0 42px
  line-height 1.5
  font-family 'Open Sans', sans-serif

  &__header
    margin-bottom 18px
    font-size 16px
    font-weight 600
    text-transform uppercase
    color: rgba(0, 0, 0, 0.85)

  &__text
    margin-bottom 18px
    font-size 16px
    font-weight 400
    color rgba(#000, .75)

  &__data
    font-size 14px
    color rgba(#000, .75)
</style>



// WEBPACK FOOTER //
// Warning.vue?751852d1